import { TicketFeeType as d } from "../../../api/models/ticket/ticket.types.js";
import { useEffect as p } from "react";
import { useGoogleAnalytics as m } from "../useGoogleAnalytics.js";
import { claimAnalyticsEvent as y } from "./eventGuard.js";
function k(...t) {
  var i;
  (i = window.dataLayer) == null || i.push(arguments);
}
const h = (t) => {
  var c, r, o, s, u, l;
  if (!y(`google:purchase:${(c = t.detail.ticket) == null ? void 0 : c.id}`))
    return;
  const i = [...t.detail.ticket.ticketItemList, ...t.detail.ticket.ticketComboList].map((e) => ({
    item_id: e.itemId,
    item_name: e.name,
    quantity: e.quantity,
    price: e.totalItems ? e.totalItems / e.quantity / 100 : e.total / 100
  })), n = ((o = (r = t.detail.ticket.ticketFees) == null ? void 0 : r.find((e) => e.feeType === d.DELIVERY)) == null ? void 0 : o.amount) ?? 0, a = ((s = t.detail.ticket.ticketService) == null ? void 0 : s.getServiceKey()) ?? "no-service";
  k("event", "purchase", {
    transaction_id: t.detail.ticket.id,
    shipping: n / 100,
    value: (((u = t.detail.ticket.ticketSummary) == null ? void 0 : u.total) ?? 0) / 100,
    currency: ((l = t.detail.ticket.ticketSummary) == null ? void 0 : l.currency) ?? "EUR",
    order_type: a,
    items: i
  });
};
function L(t, i) {
  const n = m(t, i);
  return p(() => {
    const a = (c) => h(c);
    return window.addEventListener("analytics.purchase", a), () => {
      window.removeEventListener("analytics.purchase", a);
    };
  }, []), n;
}
export {
  L as useShopGoogleAnalytics
};
//# sourceMappingURL=useShopGoogleAnalytics.js.map
